/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export enum TokenProgramVersion {
  Original,
  Token2022,
}

export type TokenProgramVersionArgs = TokenProgramVersion;

export function getTokenProgramVersionEncoder(): FixedSizeEncoder<TokenProgramVersionArgs> {
  return getEnumEncoder(TokenProgramVersion);
}

export function getTokenProgramVersionDecoder(): FixedSizeDecoder<TokenProgramVersion> {
  return getEnumDecoder(TokenProgramVersion);
}

export function getTokenProgramVersionCodec(): FixedSizeCodec<
  TokenProgramVersionArgs,
  TokenProgramVersion
> {
  return combineCodec(
    getTokenProgramVersionEncoder(),
    getTokenProgramVersionDecoder()
  );
}
